import React from "react";
import { Loader2, Pause, Play, Volume2, X } from "lucide-react";

/**
 * Presentational speech-bubble panel shown above Dr. Nesma's avatar.
 * The parent owns all state; this component is just skin + controls.
 */
export default function TeacherBubble({
  isRTL, loading, playing, error, script, onClose, onTogglePlay,
}) {
  return (
    <div
      className="w-80 max-w-[calc(100vw-2rem)] rounded-2xl bg-white border border-sage/40 shadow-[0_10px_30px_rgba(74,103,92,0.25)] overflow-hidden animate-in fade-in slide-in-from-bottom-2 duration-200"
      data-testid="teacher-bubble"
    >
      <div className="flex items-center justify-between px-4 py-2.5 bg-gradient-to-r from-sage to-sage-dark text-white">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.15em]">
          <Volume2 className="w-3.5 h-3.5" />
          {isRTL ? "د. نسمة" : "Dr. Nesma"}
        </div>
        <button
          onClick={onClose}
          data-testid="teacher-close"
          className="p-1 rounded hover:bg-white/15"
          aria-label="Close"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>

      <div className="p-4">
        {loading && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Loader2 className="w-4 h-4 animate-spin text-sage" />
            {isRTL ? "جارٍ تحضير الشرح..." : "Preparing your mini-lesson…"}
          </div>
        )}
        {error && !loading && (
          <div className="text-xs text-terracotta" data-testid="teacher-error">
            {error}
          </div>
        )}
        {!loading && !error && script && (
          <>
            <div className="text-xs text-muted-foreground leading-relaxed line-clamp-4 mb-3">
              {script}
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={onTogglePlay}
                data-testid="teacher-toggle-play"
                className="inline-flex items-center gap-1.5 bg-sage hover:bg-sage-dark text-white font-medium px-3 py-1.5 rounded-lg text-xs"
              >
                {playing ? <Pause className="w-3.5 h-3.5" /> : <Play className="w-3.5 h-3.5" />}
                {playing ? (isRTL ? "إيقاف مؤقت" : "Pause") : (isRTL ? "تشغيل" : "Play")}
              </button>
              {playing && (
                <div className="flex items-end gap-[2px] h-4" aria-hidden>
                  {[0, 1, 2, 3].map((i) => (
                    <span
                      key={`bar-${i}`}
                      className="w-[3px] bg-sage rounded-full animate-speak-bar"
                      style={{ animationDelay: `${i * 120}ms` }}
                    />
                  ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
